export default {"src":"/customer-services/_next/static/media/mobile.c20c8407.svg","height":40,"width":24,"blurWidth":0,"blurHeight":0};